import React from 'react';
import PropTypes from 'prop-types';
import { Switch as MuiSwitch, withStyles } from '@material-ui/core';

const styles = () => ({
  thumb: {
    background: "#fff",
    border: "1px solid #9f9f9f",
  },
  track: {
    height: 10,
    width: 30,
    marginTop: 1
  },
  switchBase: {

  },
  root: {
    height: "auto"
  },
  checked: {
    '&$switchBase': {
      color: '#26BBED',
      transform: 'translateX(17px) !important',
    },
    '& $thumb': {
      border: "1px solid #26bbed",
    },
    '& + $track': {
      backgroundColor: '#26BBED !important',
    },
  },
})

const Switch = withStyles(styles)(({
  toggled,
  onToggle,
  classes,
  id
}) => {
  const [checked, setChecked] = React.useState(toggled);
  React.useEffect(() => {
    setChecked(toggled)
  }, [id])
  const handleToggle = async (e) => {
    setChecked(e.target.checked)
    let response = await onToggle(e.target.checked, !e.target.checked)
    setChecked(response)
  }
  return (
    <MuiSwitch
      classes={{
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
        root: classes.root,
        switchBase: classes.switchBase
      }}
      checked={checked}
      onChange={handleToggle}
    />
  );
});

Switch.propTypes = {
  toggled: PropTypes.bool,
  setToggled: PropTypes.func
}

export default Switch;



